export default {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) || '',
  publicSentinelBaseUrl: (import.meta.env.VITE_PUBLIC_SENTINEL_BASE_URL as string) || '',

  reCaptchaKey: (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string) || '',
  reCaptchaAction: 'login',
  otpResendCooldownSeconds: Number(import.meta.env.VITE_OTP_RESEND_COOLDOWN_SECONDS ?? 60),

  sentry: {
    dsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) || '',
    environment: String(import.meta.env.VITE_APP_ENV) || 'staging',
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
    replaysSessionSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? (import.meta.env.DEV ? 0.2 : 0.05)
    ),
    replaysOnErrorSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1.0
    ),
    // Feature flags to control bundle weight
    enableTracing: (import.meta.env.VITE_SENTRY_ENABLE_TRACING as string | undefined) !== 'false',
    enableReplays: (import.meta.env.VITE_SENTRY_ENABLE_REPLAYS as string | undefined) === 'true',
    loadOnStartup: (import.meta.env.VITE_SENTRY_LOAD_ON_STARTUP as string | undefined) === 'true',
  },

  store: {
    instagram: {
      name: 'alcomarket_kr',
      link: 'https://www.instagram.com/alcomarket_kr/',
    },
    facebook: {
      name: 'veresen.kr',
      link: 'https://www.facebook.com/veresen.kr',
    },
  },
  support: {
    phone: '0800 30 96 86',
    email: 'marketing@veresen.com.ua',
    website: 'https://fayno.market/partners/veresen',
  },
};
